import React, { Suspense, useState } from "react";
import Nav from "react-bootstrap/Nav";
import { useTranslation } from "react-i18next";
import { LinkContainer } from "react-router-bootstrap";
import { isUrlPathActive } from "../utils/urlHelper";
import { useSetRecoilState } from "recoil";
import { errorState } from "../recoil/error/atom";
import ErrorBoundary from "../ErrorBoundary";

const NavBar = (props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");
  const popError = useSetRecoilState(errorState);
  const isActive = (name) => {
    const elems = window.location.pathname.split("/").filter(String);
    return (elems.length > 0 && elems[0] === name) || selected === name;
  };

  return (
    <Suspense fallback={<div style={{ textAlign: "center", padding: "5rem" }}>Loading....</div>}>
      <ErrorBoundary popError={popError}>
        <Nav className="ms-auto">
          <Nav.Item as="li">
            <Nav.Link href="/jobs/dashboard" className={isActive("jobs") ? "active" : ""}>
              <span className="d-none d-sm-block">{t("Menu.Jobs.Desktop")}</span>
              <span className="d-block d-sm-none">{t("Menu.Jobs.Mobile")}</span>
            </Nav.Link>
          </Nav.Item>
          {!isUrlPathActive("quickapplications") ? (
            <Nav.Item as="li">
              <LinkContainer to="/applications">
                <Nav.Link
                  onClick={() => {
                    setSelected("applications");
                  }}
                  className={isActive("applications") ? "active" : ""}>
                  <span className="d-none d-sm-block">{t("Menu.Applications.Desktop")}</span>
                  <span className="d-block d-sm-none">{t("Menu.Applications.Mobile")}</span>
                </Nav.Link>
              </LinkContainer>
            </Nav.Item>
          ) : null}

          {/* {!isUrlPathActive("quickapplications") ? (
            <LinkContainer to="/profile">
              <li className="nav-item" role="presentation">
                <Nav.Link
                  onClick={() => {
                    setSelected("profile");
                  }}
                  className={isActive("profile") ? "active" : ""}>
                  <span className="d-none d-sm-block">{t("Menu.Profile.Desktop")}</span>
                  <span className="d-block d-sm-none">{t("Menu.Profile.Mobile")}</span>
                </Nav.Link>
              </li>
            </LinkContainer>
          ) : null} */}

          {/* {!isUrlPathActive("quickapplications") ? (
            <LinkContainer to="/admin">
              <li className="nav-item" role="presentation">
                <Nav.Link
                  onClick={() => {
                    setSelected("admin");
                  }}
                  className={isActive("admin") ? "active" : ""}>
                  <span className="d-none d-sm-block">{t("Menu.Admin.Desktop")}</span>
                  <span className="d-block d-sm-none">{t("Menu.Admin.Mobile")}</span>
                </Nav.Link>
              </li>
            </LinkContainer>
          ) : null} */}
        </Nav>
      </ErrorBoundary>
    </Suspense>
  );
};

export default NavBar;
